<script setup lang="ts">
import Footer from "@/components/Footer.vue";
import LaureateForm from "@/components/laureate/LaureateForm.vue";
</script>

<template>
    <div class="min-h-full flex flex-col justify-between">
        <div id="laureate">
            <LaureateForm></LaureateForm>
        </div>
        <div class="bg-default-white">
            <div class="lg:w-1/2 mx-auto">
                <Footer></Footer>
            </div>
        </div>
    </div>
</template>

<style>
#app {
    min-height: 100vh;
}
#laureate {
    background-image: url("../assets/images/backgrounds/bgTransparentPeopleMobile.webp");
    background-blend-mode: color-dodge;
    background-size: contain;
    background-position: bottom;
    background-repeat: no-repeat;
}

@media only screen and (min-width: 768px) {
    #laureate {
        background-image: url("../assets/images/backgrounds/bgTransparentPeople.webp");
    }
}
</style>